import { render, staticRenderFns } from "./DonatorList.vue?vue&type=template&id=090f36a2&"
import script from "./DonatorList.vue?vue&type=script&lang=js&"
export * from "./DonatorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DonatorList.vue"
export default component.exports